import palette from './palette';

export const h1 = {
    color: palette.text.primary,
    fontFamily: "'Jost', sans-serif",
    fontWeight: '700',
    fontSize: '35px',
    letterSpacing: '-0.24px',
    lineHeight: '1.14',
};
export const h2 = {
    color: palette.text.primary,
    fontFamily: "'Jost', sans-serif",
    fontWeight: '700',
    fontSize: '29px',
    letterSpacing: '-0.24px',
    lineHeight: '1.1',
};
export const h3 = {
    color: palette.text.primary,
    fontFamily: "'Jost', sans-serif",
    fontWeight: '700',
    fontSize: '24px',
    letterSpacing: '-0.06px',
    lineHeight: '1.17',
};
export const h4 = {
    color: palette.text.secondary,
    fontFamily: "'Jost', sans-serif",
    fontWeight: '700',
    fontSize: '20px',
    letterSpacing: '-0.06px',
    lineHeight: '1.2',
};
export const h5 = {
    color: palette.text.secondary,
    fontFamily: "'Jost', sans-serif",
    fontWeight: '700',
    fontSize: '16px',
    letterSpacing: '-0.05px',
    lineHeight: '1.25',
};
export const h6 = {
    color: palette.text.secondary,
    fontFamily: "'Jost', sans-serif",
    fontWeight: '700',
    fontSize: '14px',
    letterSpacing: '-0.05px',
    lineHeight: '1.43',
};
export const subtitle1 = {
    fontFamily: "'Roboto', sans-serif",
    color: palette.text.primary,
    fontSize: '16px',
    letterSpacing: '-0.05px',
    lineHeight: '1.56',
};
export const subtitle2 = {
    fontFamily: "'Roboto', sans-serif",
    color: palette.text.primary,
    fontSize: '14px',
    letterSpacing: 0,
    lineHeight: '1.14',
};
export const body1 = {
    fontFamily: "'Roboto', sans-serif",
    color: palette.text.primary,
    fontSize: '14px',
    letterSpacing: '-0.05px',
    lineHeight: '1.5',
};
export const body2 = {
    fontFamily: "'Roboto', sans-serif",
    color: palette.text.primary,
    fontSize: '12px',
    letterSpacing: '-0.04px',
    lineHeight: '1.17',
};
export const button = {
    fontFamily: "'Jost', sans-serif",
    fontSize: '14px',
};
export const caption = {
    fontFamily: "'Roboto', sans-serif",
    color: palette.text.secondary,
    fontSize: '12px',
    letterSpacing: '0.3px',
    lineHeight: '1.33',
};
